module.exports = __webpack_public_path__ + "img/case-logo-38.be3f1da2.png";